module.exports = __webpack_public_path__ + "static/media/seatsTemplateIcon.svg";